import React, { Fragment } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Box, Typography } from "@material-ui/core";
import Submit from "../../components/Submit";
import { useTranslation } from "react-i18next";

const validationSchema = Yup.object().shape({
  eklok: Yup.string().required("Serial id is required"),
});

const ActiveEklokForm = ({
  onSubmit = () => {},
  initialValues,
  activationCode,
}) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      {activationCode ? (
        <Fragment>
          {Object.keys(activationCode).map((key) => (
            <Typography variant="h4" align="center">
              {key}: {activationCode[key]}
            </Typography>
          ))}
        </Fragment>
      ) : (
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {(props) => (
            <form onSubmit={props.handleSubmit}>
              <Box my={2}>
                <Submit {...props} title={t("active_eklok.generate_code")} />
              </Box>
            </form>
          )}
        </Formik>
      )}
    </Fragment>
  );
};

export default ActiveEklokForm;
